export function formatCurrency(value: number): string {
  const formatted = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
  return `R$${formatted}`;
}

/** "24/06/2025" */
export function formatDate(dateString: string): string {
  const date = new Date(dateString + 'T00:00:00');
  return new Intl.DateTimeFormat('pt-BR').format(date);
}

const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];
const WEEKDAYS_LONG  = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
const MONTHS_SHORT   = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
const MONTHS_LONG    = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

function parseLocalDate(dateString: string): Date {
  const iso = String(dateString).substring(0, 10);
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

/** "QUA 24/06" */
export function formatDateShort(dateString: string): string {
  const d = parseLocalDate(dateString);
  return `${WEEKDAYS_SHORT[d.getDay()]} ${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}`;
}

/** "Quarta-feira, 24 de junho" */
export function formatDateLong(dateString: string): string {
  const d = parseLocalDate(dateString);
  return `${WEEKDAYS_LONG[d.getDay()]}, ${d.getDate()} de ${MONTHS_LONG[d.getMonth()]}`;
}

/** "24 de jun de 2025" */
export function formatDateMedium(dateString: string): string {
  const d = parseLocalDate(dateString);
  return `${d.getDate()} de ${MONTHS_SHORT[d.getMonth()]} de ${d.getFullYear()}`;
}

/** "HH:MM" — aceita "HH:MM:SS" ou "HH:MM" */
export function formatTime(time: string): string {
  return time.substring(0, 5);
}
